/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import AdminRoutes from './admin.routes';
import AdminController from './admin.controller';

export default angular.module('tektelic.admin', [])
    .config(AdminRoutes)
    .controller('AdminController', AdminController)
    .name;



// WEBPACK FOOTER //
// ./src/app/admin/index.js